module.exports = __webpack_public_path__ + "assets/svg/UI/copy-02bef9.svg";